import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  selectCurrentUserName,
  unSetCurrentUserName,
} from "../reset/resetSlice";
import { useResetMutation, useUpdateMutation } from "./resetApiSlice";
import { showLoader, hideLoader } from "../../app/api/appApiSlice";

const UpdatePassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const verifyUsername = useSelector(selectCurrentUserName);

  const [reset, { isSuccess: isResetSuccess, isError: isResetError }] =
    useResetMutation();
  const [update, { isSuccess, isError }] = useUpdateMutation();

  const [username, setUsername] = useState(verifyUsername || "");
  const [errUsername, setErrUsername] = useState(false);
  const [otp, setOtp] = useState("");
  const [errOtp, setErrOtp] = useState(false);
  const [password, setPassword] = useState("");
  const [errPassword, setErrPassword] = useState(false);
  const [confPassword, setConfPassword] = useState("");
  const [errConfPassword, setErrConfPassword] = useState(false);
  const [resendStatus, setResendStatus] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errMsg, setErrMsg] = useState("");

  setTimeout(() => {
    if (verifyUsername) {
      setSuccessMsg("");
      setResendStatus(true);
    }
  }, 1000 * 60 * 3);

  const resendOTP = async (e) => {
    e.preventDefault();

    if (!verifyUsername) {
      return;
    }

    try {
      dispatch(showLoader());
      await reset({ username: verifyUsername }).unwrap();
    } catch (err) {
      if (err.data?.message) {
        setErrMsg(err.data?.message);
      } else {
        setErrMsg("Please try again later.!");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username) {
      setErrUsername(true);
    }

    if (!otp) {
      setErrOtp(true);
    }

    if (!password) {
      setErrPassword(true);
    }

    if (!confPassword) {
      setErrConfPassword(true);
    }

    if (!otp || !username || !password || !confPassword) {
      return;
    }

    try {
      dispatch(showLoader());
      await update({
        otpcode: otp,
        username,
        password,
      }).unwrap();
    } catch (err) {
      if (err.data?.message) {
        setErrMsg(err.data?.message);
      } else {
        setErrMsg("Please try again later.!");
      }
    }
  };

  useEffect(() => {
    if (isResetSuccess) {
      setErrMsg("");

      setTimeout(async () => {
        setResendStatus(false);
        setSuccessMsg(
          "Please check your email inbox for the verification code.!"
        );

        dispatch(hideLoader());
      }, 3000);
    }

    if (isResetError) {
      dispatch(hideLoader());
    }
  }, [isResetSuccess, isResetError]);

  useEffect(() => {
    if (isSuccess) {
      setErrMsg("");

      setTimeout(async () => {
        setOtp("");
        setUsername("");
        setPassword("");
        setConfPassword("");

        dispatch(hideLoader());

        dispatch(unSetCurrentUserName());

        navigate("/");
      }, 3000);
    }

    if (isError) {
      dispatch(hideLoader());
    }
  }, [isSuccess, isError]);

  return (
    <section className="flex items-center justify-center xs:min-h-[calc(100vh-68px)] py-10 mx-auto">
      <div className="flex items-center justify-center flex-wrap gap-16 sm:gap-40 p-4 xs:p-8 sm:p-20 mx-auto rounded-xl xs:shadow-lg">
        <div className="text-center">
          <img
            className="w-[300px] mx-auto mb-4"
            src="/img/dashboard.png"
            alt="intro image"
          />
          <p className="text-base sm:text-2xl">
            If you are already member?
            <br />
            Please go to the signin page.
          </p>
          <div className="mt-4">
            <Link
              className="inline-block bg-black text-white uppercase p-3 rounded-md"
              to="/"
            >
              Sign In
            </Link>
          </div>
        </div>
        <div className="flex flex-col justify-center xs:justify-start w-[300px] max-w-[calc(100%-30px)]">
          <h1 className="text-3xl text-center uppercase mb-6">
            Update Password
          </h1>
          <form method="post" onSubmit={handleSubmit}>
            {!verifyUsername && (
              <div className="mb-4">
                <div
                  className={`py-[10px] px-[12px] border-[1px] rounded-md ${
                    errUsername && "text-error border-error"
                  }`}
                >
                  <label htmlFor="username" className="block text-xs">
                    Username *
                  </label>
                  <input
                    id="username"
                    name="username"
                    type="email"
                    className="focus-visible:outline-none"
                    value={username}
                    onChange={(e) => {
                      setUsername(e.target.value);
                      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                      if (!emailRegex.test(e.target.value)) {
                        setErrUsername(true);
                      } else {
                        setErrUsername(false);
                      }
                    }}
                    autoComplete="false"
                  />
                </div>
                {errUsername && (
                  <span className="text-xs text-error">
                    Please enter a valid email address.
                  </span>
                )}
              </div>
            )}
            <div
              className={`w-full py-[10px] px-[12px] mb-4 border-[1px] rounded-md ${
                errOtp && "text-error border-error"
              }`}
            >
              <label htmlFor="otp" className="block text-xs">
                OTP Code *
              </label>
              <input
                id="otp"
                name="otp"
                type="text"
                placeholder=""
                className="w-full focus-visible:outline-none"
                value={otp}
                onChange={(e) => {
                  setOtp(e.target.value.replace(/[^0-9]/g, ""));
                  if (e.target.value.replace(/[^0-9]/g, "")) {
                    setErrOtp(false);
                  } else {
                    setErrOtp(true);
                  }
                }}
                autoComplete="false"
              />
            </div>
            <div className="mb-4">
              <div
                className={`py-[10px] px-[12px] border-[1px] rounded-md ${
                  errPassword && "text-error border-error"
                }`}
              >
                <label htmlFor="password" className="block text-xs">
                  Password *
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  placeholder=""
                  className="w-full focus-visible:outline-none"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    if (e.target.value && e.target.value.length > 8) {
                      setErrPassword(false);
                    } else {
                      setErrPassword(true);
                    }
                  }}
                  autoComplete="false"
                />
              </div>
              {errPassword && (
                <span className="text-xs text-error">
                  Password must be more than 8 characters long.
                </span>
              )}
            </div>
            <div className="mb-4">
              <div
                className={`py-[10px] px-[12px] border-[1px] rounded-md ${
                  errConfPassword && "text-error border-error"
                }`}
              >
                <label htmlFor="conf-password" className="block text-xs">
                  Confirm Password *
                </label>
                <input
                  id="conf-password"
                  name="conf-password"
                  type="password"
                  placeholder=""
                  className="w-full focus-visible:outline-none"
                  value={confPassword}
                  onChange={(e) => {
                    setConfPassword(e.target.value);
                    if (e.target.value && password === e.target.value) {
                      setErrConfPassword(false);
                    } else {
                      setErrConfPassword(true);
                    }
                  }}
                  autoComplete="false"
                />
              </div>
              {errConfPassword && (
                <span className="text-xs text-error">
                  Password does not matched.
                </span>
              )}
            </div>
            {resendStatus && (
              <button
                className="text-xs text-black underline"
                onClick={resendOTP}
              >
                Resend OTP
              </button>
            )}
            <div className="text-center mt-4">
              <button
                type="submit"
                className="max-w-fit bg-black text-white uppercase p-3 rounded-md"
              >
                Update
              </button>
            </div>
            {successMsg && (
              <div className="max-w-max text-center text-black py-2 px-4 mt-4 mx-auto rounded-md">
                {successMsg}
              </div>
            )}
            {errMsg && (
              <div className="max-w-max text-center text-error py-2 px-4 mt-4 mx-auto rounded-md">
                {errMsg}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default UpdatePassword;
